// extracted by mini-css-extract-plugin
export default {"moreInfo":"style_moreInfo__ZOh6k","content":"style_content__2JWdB","rules":"style_rules__69P+e"};